import { CellPlugin } from '@react-page/editor';
import { Col, Row } from 'react-bootstrap';

type Data = {
    useOldUrlPaths?: boolean;
    oldPrivacyPolicyPath: string;
    oldPrivacyOpenInNewWindow?: boolean;
    oldTermsOfUsePath: string;
    oldTermsOfUseOpenInNewWindow?: boolean;
    oldTermsConditionsPath: string;
    oldTermsAndConditionsOpenInNewWindow?: boolean;
    privacyPolicyPath: string;
    privacyPolicyOpenInNewWindow?: boolean;
    termsOfUsePath: string;
    termsUseOpenInNewWindow?: boolean;
    termsConditionsPath: string;
    termsConditionsOpenInNewWindow?: boolean;
    privacyPolicyLabel: string;
    termsOfUseLabel: string;
    termsConditionsLabel: string;
    fontColor: string;
    textFontColor: string;
};

const FONT_COLOR = '#000000';
const TEXT_FONT_COLOR = '#000000';

const checkStyleForDefault = (style: string, defaultStyle: string) =>
    style && style !== '' ? style : defaultStyle;

const getPolicyData = (useOld: boolean | undefined, oldPath: string, newPath: string, oldNewWindow?: boolean, newNewWindow?: boolean) =>
({
    href: useOld ? oldPath : newPath,
    target: (useOld ? oldNewWindow : newNewWindow) ? '_blank' : undefined,
});

const defaults = {
    privacyPolicyPath: 'https://payments.msbpay.com/Privacy_Policy.pdf',
    termsOfUsePath: 'https://payments.msbpay.com/Terms_Of_Use.pdf',
    termsConditionsPath: 'https://payments.msbpay.com/Payment_Terms_and_Conditions.pdf',
    oldPrivacyPolicyPath: 'https://payments.msbpay.navient.com/Privacy_Policy.pdf',
    oldTermsOfUsePath: 'https://payments.msbpay.navient.com/Terms_Of_Use.pdf',
    oldTermsConditionsPath: 'https://payments.msbpay.navient.com/Payment_Terms_and_Conditions.pdf',
    privacyPolicyLabel: 'Privacy Policy',
    termsOfUseLabel: 'Terms of Use',
    termsConditionsLabel: 'Terms and Conditions',
  };

const FooterPrivacyPolicyTermsCondition: CellPlugin<Data> = {
    Renderer: ({ data }) => {
        const privacy = getPolicyData(data.useOldUrlPaths, data.oldPrivacyPolicyPath || defaults.oldPrivacyPolicyPath, data.privacyPolicyPath || defaults.privacyPolicyPath, data.oldPrivacyOpenInNewWindow, data.privacyPolicyOpenInNewWindow);
        const termsOfUse = getPolicyData(data.useOldUrlPaths, data.oldTermsOfUsePath || defaults.oldTermsOfUsePath, data.termsOfUsePath || defaults.termsOfUsePath, data.oldTermsOfUseOpenInNewWindow, data.termsUseOpenInNewWindow);
        const termsConditions = getPolicyData(data.useOldUrlPaths, data.oldTermsConditionsPath || defaults.oldTermsConditionsPath, data.termsConditionsPath || defaults.termsConditionsPath, data.oldTermsAndConditionsOpenInNewWindow, data.termsConditionsOpenInNewWindow);
        
        return (
            <Row>
                <Col lg={12}>
                    <p className="mb-0 text-center" style={{ color: checkStyleForDefault(data.textFontColor, TEXT_FONT_COLOR) }} >
                        By continuing, you agree to accept our
                        <a href={privacy.href} target={privacy.target} style={{ color: checkStyleForDefault(data.fontColor, FONT_COLOR) }} >
                            {' '}{data.privacyPolicyLabel || defaults.privacyPolicyLabel}
                        </a>,
                        <a href={termsOfUse.href} target={termsOfUse.target} style={{ color: checkStyleForDefault(data.fontColor, FONT_COLOR) }} >
                            {' '}{data.termsOfUseLabel || defaults.termsOfUseLabel}
                        </a> and
                        <a href={termsConditions.href} target={termsConditions.target} style={{ color: checkStyleForDefault(data.fontColor, FONT_COLOR) }} >
                            {' '}{data.termsConditionsLabel || defaults.termsConditionsLabel}
                        </a>.
                    </p>
                </Col>
            </Row>
        );
    },

    id: 'footerPrivacyPolicyTermsCondition',
    title: 'Privacy, Terms & Condition Footer',
    description: 'A generic privacy, terms & conditions footer.',
    version: 1,
    controls: [
        {
            title: 'URL version',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        useOldUrlPaths: {
                            type: 'boolean',
                            title: 'Use legacy (navient.com) URLs',
                            default: false,
                        },
                        oldPrivacyPolicyPath: {
                            type: 'string',
                            default: defaults.oldPrivacyPolicyPath,
                        },
                        oldPrivacyOpenInNewWindow: { type: 'boolean' },
                        oldTermsOfUsePath: {
                            type: 'string',
                            default: defaults.oldTermsOfUsePath,
                        },
                        oldTermsOfUseOpenInNewWindow: { type: 'boolean' },
                        oldTermsConditionsPath: {
                            type: 'string',
                            default: defaults.oldTermsConditionsPath,
                        },
                        oldTermsAndConditionsOpenInNewWindow: { type: 'boolean' },
                    },
                },
            },
        },
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        privacyPolicyLabel: { type: 'string', default: 'Privacy Policy' },
                        termsOfUseLabel: { type: 'string', default: 'Terms of Use' },
                        termsConditionsLabel: { type: 'string', default: 'Terms and Conditions' },
                    },
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        fontColor: { type: 'string', default: FONT_COLOR },
                        textFontColor: { type: 'string', default: TEXT_FONT_COLOR },
                    },
                },
            },
        },
        {
            title: 'Policy links',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        privacyPolicyPath: {
                            type: 'string',
                            default: defaults.privacyPolicyPath,
                        },
                        privacyPolicyOpenInNewWindow: { type: 'boolean' },
                        termsOfUsePath: {
                            type: 'string',
                            default: defaults.termsOfUsePath,
                        },
                        termsUseOpenInNewWindow: { type: 'boolean' },
                        termsConditionsPath: {
                            type: 'string',
                            default: defaults.termsConditionsPath,
                        },
                        termsConditionsOpenInNewWindow: { type: 'boolean' },
                    },
                },
            },
        },
    ],
};

export default FooterPrivacyPolicyTermsCondition;